import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { decryptAESID } from '../../../utils/Encryption';
import { useLazyGetPDFQuery } from '../../../app/services/common/commonServiceApi';
import { useGetFinancialInformationByIdMutation, useCancelInvoiceForIndividualMembershipMutation } from '../../../app/services/ViewIndividulaMember/ViewIndividualMemberServiceApi';
import ToastService from '../../../services/toastService/ToastService';
import { saveAs } from "file-saver";
import Buttons from '../../../components/ui/button/Buttons';
import SwalAlert from '../../../services/swalService/SwalService';
import { getAuditContext } from '../../../lib/authenticationLibrary';
const FinancialRecord = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { confirm, success, error } = SwalAlert();
    const audit = getAuditContext();
    const memberId = Number(decryptAESID(params.memberId));
    const [invoiceFileName, setInvoiceFileName] = useState({});
    const [certificateFileName, setCertificateFileName] = useState({});
    const [receiptFilename, setReceiptFileName] = useState({});
    const [financialData, setFinancialData] = useState({});
    const [getPDF] = useLazyGetPDFQuery();
    const [getfinancialInformationbyId, { data: financialInformationbyIdResponse, isSuccess: isfinancialInformationbyIdSuccess, isLoading: isfinancialInformationbyIdLoading }] = useGetFinancialInformationByIdMutation();
    const [cancelInvoiceForIndividualMembership, {
        isLoading: cancelInvoiceForIndividualMembershipIsLoading,
        data: cancelInvoiceForIndividualMembershipData,
        isSuccess: cancelInvoiceForIndividualMembershipIsSuccess }] = useCancelInvoiceForIndividualMembershipMutation();

    const getIPASMembersFinancialInformation = () => {
        let financeInfoRequest = { IpasMemberId: memberId };
        getfinancialInformationbyId(financeInfoRequest)
    }

    useEffect(() => {
        getIPASMembersFinancialInformation();
    }, [])
    useEffect(() => {
        if (!cancelInvoiceForIndividualMembershipIsLoading && cancelInvoiceForIndividualMembershipData && cancelInvoiceForIndividualMembershipIsSuccess) {
            success("Cancel Invoice request has been updated successfully", "Success").then(() => { handleBack() });
        }
    }, [cancelInvoiceForIndividualMembershipIsLoading, cancelInvoiceForIndividualMembershipData, cancelInvoiceForIndividualMembershipIsSuccess]);
    const handleBack = () => {
        // navigate(-1);
        getIPASMembersFinancialInformation()
    }
    useEffect(() => {
        if (!isfinancialInformationbyIdLoading && isfinancialInformationbyIdSuccess && financialInformationbyIdResponse) {
            let getInvoiceArr = financialInformationbyIdResponse.invoicePath
                ? financialInformationbyIdResponse.invoicePath.split("\\")
                : [];
            let invoiceFilename =
                getInvoiceArr.length > 1 ? getInvoiceArr[getInvoiceArr.length - 1] : "";
            let getcertificateArr = financialInformationbyIdResponse.certificatePath
                ? financialInformationbyIdResponse.certificatePath.split("\\")
                : [];
            let certificateFilename =
                getcertificateArr.length > 1
                    ? getcertificateArr[getcertificateArr.length - 1]
                    : "";
            let getreceiptArr = financialInformationbyIdResponse.receiptPath
                ? financialInformationbyIdResponse.receiptePath.split("\\")
                : [];
            let receiptFilename =
                getreceiptArr.length > 1
                    ? getreceiptArr[getreceiptArr.length - 1]
                    : "";
            setInvoiceFileName(invoiceFilename);
            setCertificateFileName(certificateFilename);
            setReceiptFileName(receiptFilename);
            setFinancialData(financialInformationbyIdResponse);
        }
    })
    const onInvoiceReceiptFileDownload = async (flag, name, field) => {
        const fileName = name.split("\\").pop();
        let request = {
            type: flag,
            fileName: name,
        };
        const response = await getPDF(request);

        if (response?.data) {
            if (field === "invoice") {
                saveAs(response?.data?.fileData, fileName);
            }
            else if (field === "receipt") {
                saveAs(response?.data?.fileData, fileName);
            }
            else if (field === "certificate") {
                saveAs(response?.data?.fileData, fileName);
            }


        } else {
            ToastService.error("Something Went Wrong");
        }
    };
    const cancelInvoice = (membershipPaymentId) => {
        confirm('Cancel?', 'Are You Sure You Want to Cancel This Invoice?', 'Yes', 'No').then((confirmed) => {
            if (confirmed) {
                let request = {
                    MembershipPaymentId: membershipPaymentId,
                    UpdatedBy: audit.adminUserId,
                    UpdatedAppId: audit.appId,
                }
                cancelInvoiceForIndividualMembership(request);
            }
        });
    }

    return (
        <>
            {financialInformationbyIdResponse?.map((item, key) => {
                return (
                    <>
                        <div className="financial-record">
                            <div
                                className="row col-lg-12 position-relative financial-record-separator"
                                key={key}
                            >
                                <div
                                    className={`${item.paymentStatus === "Success"
                                        ? "paid-lable"
                                        : "pending-lable"
                                        }`}
                                >
                                    <span className="fs-6">
                                        {item.paymentStatus === "Success" ? "Paid" : item.paymentStatus}
                                    </span>
                                </div>

                                <div className="row financial-record-group">
                                    <div className="col-lg-4 col-xl-4 col-md-4 col-sm-12 col-12 ">
                                        <div>
                                            <label>Invoice Number :</label>
                                            <span> {item.membershipPaymentInvoiceNo}</span>
                                        </div>
                                        <div>
                                            <label>Date :</label>
                                            {/* <span> {new Date(item.paymentDate).toLocaleDateString('en-GB')}</span> */}
                                            <span> {new Date(item?.paymentDate).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                            })}</span>
                                        </div>
                                        <div>
                                            <label>Payment Status :</label>
                                            <span>
                                                {" "}
                                                {item.paymentStatus ? item.paymentStatus : ""}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 d-flex justify-content-between">
                                        <div className="mr-5">
                                            <div>
                                                <label>Promotion Code :</label>
                                                <span> N.A</span>
                                            </div>
                                            <div>
                                                <label>Amount(Billable) :</label>
                                                <span>
                                                    S$
                                                    {parseFloat(item.totalAmount).toLocaleString(
                                                        "en-US",
                                                        {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        }
                                                    )}
                                                </span>
                                            </div>
                                            <div>
                                                <label>Amount(Paid) :</label>
                                                <span>
                                                    S$
                                                    {item.paymentStatus === "Success"
                                                        ? parseFloat(item.totalAmount).toLocaleString(
                                                            "en-US",
                                                            {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2,
                                                            }
                                                        )
                                                        : parseFloat(0).toLocaleString("en-US", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="text-end record-btn ">
                                            <Buttons
                                                buttonText="View Invoice"
                                                // buttonTypeClassName="outline-theme-btn btn mb-3 "
                                                buttonTypeClassName={`outline-theme-btn btn mb-3 ${item.invoicePath === null ? "d-none" : ""}`}

                                                disabled={!item?.invoicePath}
                                                onClick={() =>
                                                    item?.invoicePath
                                                        ? onInvoiceReceiptFileDownload("FullFilePath", item?.invoicePath, "invoice")
                                                        : console.warn("Invoice is not existed")
                                                }
                                            />
                                            <Buttons
                                                buttonText="View Receipt"

                                                buttonTypeClassName={`outline-theme-btn btn  mb-3 ${item.receiptPath === null ? "d-none" : ""}`}
                                                disabled={!item?.receiptPath}
                                                onClick={() =>
                                                    item?.receiptPath
                                                        ? onInvoiceReceiptFileDownload("FullFilePath", item?.receiptPath, "receipt")
                                                        : console.warn("Receipt is not existed")
                                                }
                                            />
                                            {item?.membershipType !== 4 && (
                                                <Buttons
                                                buttonText="View Certificate"

                                                buttonTypeClassName={`outline-theme-btn btn ${item.certificatePath === null ? "d-none" : ""}`}
                                                disabled={!item?.certificatePath}
                                                onClick={() =>
                                                    item?.certificatePath
                                                        ? onInvoiceReceiptFileDownload("FullFilePath", item?.certificatePath, "certificate")
                                                        : console.warn("Certificate is not existed")
                                                }
                                            />)
                                            }
                                            <Buttons
                                                buttonText="Cancel Invoice"

                                                buttonTypeClassName={`outline-theme-btn btn ${item.paymentStatus !== "Pending" ? "d-none" : ""}`}
                                                disabled={!item.paymentStatus}
                                                onClick={() =>
                                                    item?.paymentStatus === "Pending"
                                                        ? cancelInvoice(item?.membershipPaymentId)
                                                        : console.warn("Cancel Invoice")
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            })}
        </>
    )
}

export default FinancialRecord
